// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__33QBY","content":"Consent_content__BagoF","footer":"Consent_footer__1GLrg"};